import React from 'react';
import {
  isMobileOnly,
  isTablet,
} from 'react-device-detect';
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CButton,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {cilX} from '@coreui/icons';
import {hideReportModal} from './reports-actions';
import styles from './Reports';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const WeatherStationModal = () => {

  const dispatch = useDispatch();

  const {
    tableauTokenForSelectedReport,
    selectedReportUrl,
    selectedReportTitle,
    reportModalVisible,
  } = useSelector(state => state.reports);

  const growerId = useSelector(state => state.auth.authorization.growerId);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  const height = windowHeight - 71;

  var width = windowWidth;

  return (
    <CModal
      fullscreen
      alignment='center'
      scrollable
      visible={reportModalVisible} >
      <CModalHeader closeButton={false}>
        <CModalTitle className={styles.modalTitle}>
          {selectedReportTitle}
        </CModalTitle>
        <CButton className={styles.modalCloseButton} onClick={() => dispatch(hideReportModal())}>
          <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
        </CButton>
      </CModalHeader>
      <CModalBody style={{padding: 0,}}>
      {
        tableauTokenForSelectedReport !== null ? (
          <div style={{width: width, height: height,}}>
            <tableau-viz
              src={selectedReportUrl}
              token={tableauTokenForSelectedReport}
              toolbar='bottom'
              hide-tabs
              device={isMobileOnly === true ? 'phone' : 'desktop'}
              width={width}
              height={height}
              touch-optimize={isMobileOnly || isTablet ? true : undefined}>
              <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
            </tableau-viz>
          </div>
        ) : null
      }
      </CModalBody>
    </CModal>
  );
}

export default WeatherStationModal;
